import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('ANALYTICS', {
  FETCH_DATALAYER_REQUEST: null,
  FETCH_DATALAYER_SUCCESS: null,
  FETCH_DATALAYER_FAILURE: null
});



// WEBPACK FOOTER //
// ./app/constants/AnalyticsConstants.js